<template>
    <div v-if="images">
        <h3
            class="font-Inter-Bold pb-3 w-full block border-b border-dashed border-black border-opacity-20 text-xl mb-7"
        >
            {{ $t('products.gallery') }}
        </h3>
        <div v-if="images" class="grid grid-cols-12 gap-y-4 lg:gap-4">
            <div
                v-for="(image, i) in images.slice(0, 7)"
                :key="`gallery-image-${i}`"
                class="col-span-12 md:col-span-6 relative group"
                :class="{
                    'lg:col-span-8': i === 0 || i === 6,
                    'lg:col-span-4': i === 1 || i === 2 || i === 3 || i === 4 || i === 5 || i > 6,
                }"
            >
                <div
                    class="rounded-md overflow-hidden border border-black border-opacity-5 gallery-image h-full"
                    :class="{
                        'aspect-w-4 aspect-h-3 lg:aspect-w-16 lg:aspect-h-9': i === 0 || i === 6,
                        'aspect-w-4 aspect-h-3': i === 1 || i === 2 || i === 3 || i === 4 || i > 6,
                    }"
                >
                    <app-image
                        class="object-cover object-center h-full"
                        :src="image.image || require(`~/assets/images/dev/editor/${image.src}`)"
                        :alt="image.name || ''"
                        preset="photo"
                    />
                </div>
                <button
                    class="zoom-button text-xl hidden lg:flex items-center justify-center rounded-full w-10 h-10 bg-white bg-no-repeat bg-center absolute right-4 top-4 cursor-pointer z-10 transition opacity-100 lg:opacity-0 group-hover:opacity-100"
                    @click="openLightbox(image.image || require(`~/assets/images/dev/editor/${image.src}`))"
                >
                    <i class="ri-zoom-in-line"></i>
                </button>
            </div>
        </div>
        <BaseModal :close="closeLightbox" :is-open="isLightboxOpen">
            <img
                v-if="currentImage"
                :src="currentImage"
                :alt="currentImage"
                class="rounded-md h-[50vh] max-h-[85vh] lg:h-auto object-cover"
            />
        </BaseModal>
    </div>
</template>

<script>
import BaseModal from '@/components/UI/BaseModal.vue';
export default {
    name: 'GallerySection',
    components: {
        BaseModal,
    },
    props: {
        images: {
            type: Array,
            required: true,
        },
        folder: {
            type: String,
            required: false,
            default: 'products/',
        },
    },
    data() {
        return {
            currentImage: null,
            isLightboxOpen: false,
        };
    },
    methods: {
        openLightbox(image) {
            if (image) {
                this.currentImage = image;
            } else {
                this.currentImage = this.model.image;
            }
            this.isLightboxOpen = true;
        },
        closeLightbox() {
            this.currentImage = null;
            this.isLightboxOpen = false;
        },
    },
};
</script>
